import { Component, inject, Input, OnChanges } from '@angular/core';
import { TranslationService } from '../../services/translationService';

@Component({
  selector: 'pixl-lang',
  template: '{{ translatedText }}'
})
export class TranslateComponent implements OnChanges {
  @Input() key!: string;
  @Input() keyPrefix?: string;
  @Input() keySuffix?: string;
  translatedText = '';
  translationService = inject(TranslationService);

  ngOnChanges() {
    if (this.key) {
      this.translateKey();
    }
  }

  private translateKey() {
    const keyToTranslate = this.keyPrefix ? this.keyPrefix + '.' + this.key : this.keySuffix ? this.key + '.' + this.keySuffix : this.key;
    this.translatedText = this.translationService.translate(keyToTranslate) || `?${keyToTranslate}?`;
  }
}
